export default __webpack_public_path__ + "static/media/img-hero-doando.8d2ce792.png";